import React, { FC } from 'react';

import classNames from 'classnames';

import { LinkContainer } from './NavigationLinksContainer';
import SubNavigationLayout from './SubNavigationLayout';
import { NavigationLink } from './NavigationLink';

import './OrderAssistantNavigation.scss';
import { BOLINDA_ICON_ASSISTANT } from '../common/Button/Icon';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly isSticky?: boolean;
};

const OrderAssistantNavigation: FC<Props> = ({ isSticky }) => {
    const { t } = useTranslation();
    return (
        <SubNavigationLayout
            className={classNames('order-assistant-nav', isSticky && 'order-assistant-nav--sticky')}
            left={
                <div className="order-assistant-nav-label">
                    <i className="bolinda-icons orange" aria-hidden={true}>
                        {BOLINDA_ICON_ASSISTANT}
                    </i>
                    <span>{t('menu.shop.orderingAssistantMain')}</span>
                </div>
            }
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to="/assistant/reserves">
                            {t('menu.shop.orderingAssistant.resreveReports')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to="/assistant/subscriptions">
                            {t('menu.shop.orderingAssistant.subscriptions')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            isSticky={isSticky}
            width="30"
        />
    );
};

export default OrderAssistantNavigation;
